import React, { useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import dayjs from "dayjs";
import api from "../../services/api"; // adjust if your path is different

const defaultSeedSlots = [
  { time: "10:00 AM", max: 4 },
  { time: "12:00 PM", max: 4 },
  { time: "2:00 PM", max: 4 },
  { time: "4:00 PM", max: 4 },
];

const SeedAvailabilitySection = () => {
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [numDays, setNumDays] = useState(30);
  const [seedSlots, setSeedSlots] = useState(defaultSeedSlots);
  const [loading, setLoading] = useState(false);

  const handleSeed = async () => {
    setLoading(true);
    try {
      await api.post("/availability/seed", {
        startDate,
        numDays,
        slots: seedSlots,
      });
      alert("Availability seeded successfully!");
    } catch (err) {
      console.error("Seeding failed", err);
      alert("Error seeding availability");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box mt={5}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Seed Availability
      </Typography>

      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" mb={2}>
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <TextField
          label="Number of Days"
          type="number"
          value={numDays}
          onChange={(e) => setNumDays(+e.target.value)}
        />
        <Button variant="contained" onClick={handleSeed} disabled={loading}>
          {loading ? "Seeding..." : "Generate Days"}
        </Button>
      </Box>

      <Typography variant="subtitle1" fontWeight="medium" mb={1}>
        Time Slots to Apply:
      </Typography>

      {seedSlots.map((slot, i) => (
        <Box key={i} display="flex" alignItems="center" gap={2} mt={1}>
          <TextField
            label="Time"
            value={slot.time}
            onChange={(e) =>
              setSeedSlots((prev) =>
                prev.map((s, idx) =>
                  idx === i ? { ...s, time: e.target.value } : s
                )
              )
            }
          />
          <TextField
            label="Max"
            type="number"
            value={slot.max}
            onChange={(e) =>
              setSeedSlots((prev) =>
                prev.map((s, idx) =>
                  idx === i ? { ...s, max: +e.target.value } : s
                )
              )
            }
          />
        </Box>
      ))}
    </Box>
  );
};

export default SeedAvailabilitySection;
